export type CountryCode = {
  iso2: string;
  dialCode: string;
  name: string;
  flag: string;
  minLength: number;
  maxLength: number;
};

import COUNTRY_CODES_DATA from "./country-codes-data.json";

export const COUNTRY_CODES: CountryCode[] = COUNTRY_CODES_DATA;

export const getCountryByDialCode = (dialCode: string) => {
  return COUNTRY_CODES.find((c) => c.dialCode === dialCode);
};

export const getCountryByPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber.startsWith("+")) return null;
  const sortedCountries = [...COUNTRY_CODES].sort(
    (a, b) => b.dialCode.length - a.dialCode.length,
  );
  return sortedCountries.find((c) => phoneNumber.startsWith(c.dialCode));
};

export const DEFAULT_DIAL_CODE = "+91";
export const getPhoneLengthByDialCode = (dialCode: string) => {
  return COUNTRY_CODES.find((c) => c.dialCode === dialCode)?.maxLength || 15;
};
